<template>
  <widget-field-attachment-layout
    :has-error="!!error"
    @remove="$emit('remove')"
  >
    <widget-attachment-regular-layout
      :mime-type="mimeType"
      :name="name"
      :size="size"
      :preview-url="previewUrl"
    >
      <template v-slot:details>
        <span
          v-if="error"
          class="error--text widget-field-uploading-attachment__error"
        >
          {{ $t('common.uploadError') }}

          <widget-help-icon-tooltip
            v-if="error.text"
            :tooltip="error.text"
            icon="tmi-help"
            icon-size="14px"
            icon-class="error--text"
          />
          <template v-if="error.canRetry">
            &nbsp;
            <widget-link
              variant="primary"
              size="12"
              @click="$emit('retry')"
            >
              {{ $t('common.retry') }}
            </widget-link>
          </template>
        </span>

        <div
          v-else
          class="widget-field-uploading-attachment__progress"
        >
          <widget-progress :value="uploadProgressValue" />
        </div>
      </template>
    </widget-attachment-regular-layout>
  </widget-field-attachment-layout>
</template>

<script lang="ts" setup>
import WidgetAttachmentRegularLayout from '@widgets/shared/components/attachment/WidgetAttachmentRegularLayout.vue'
import WidgetProgress from '@widgets/shared/components/WidgetProgress.vue'
import WidgetFieldAttachmentLayout from '@widgets/shared/components/attachment/field/WidgetFieldAttachmentLayout.vue'
import WidgetLink from '@widgets/shared/components/WidgetLink.vue'
import WidgetHelpIconTooltip from '@widgets/shared/components/WidgetHelpIconTooltip.vue'
import type { WidgetUploadingAttachmentError } from '@widgets/shared/types'
import { computed } from '@/composition/vue/compositionApi'

const { mimeType, name, size, previewUrl, uploadProgress } = defineProps<{
  mimeType: string // application/pdf
  name: string // file.pdf
  size: number // in bytes
  uploadProgress: number // part of size in bytes
  previewUrl?: string
  error?: WidgetUploadingAttachmentError
}>()

defineEmits<{
  (event: 'retry'): void
  (event: 'remove'): void
}>()

const uploadProgressValue = computed(() => uploadProgress / size)
</script>

<style lang="scss" scoped>
@import '@/styles/custom-variables';

.widget-field-uploading-attachment {
  &__progress {
    width: calc(100% + #{$widgetAttachmentContentRightOffset});
    padding: 6px 0;
  }

  &__error {
    display: flex;
    align-items: center;
  }
}
</style>
